import React from 'react';
import logo from "../assets/images/logo.png"
import Image from './Image';

const Header = () => {

    return (
        <div className='main_container'>
            <header 
                className='pt-[40px] pb-[35px] main_container flex justify-between items-center'
                data-aos="fade-in"
                data-aos-delay="000"
                data-aos-duration="1000"
                data-aos-easing="ease-in-out"
            >
                <div className='flex items-center gap-[12px]'>
                    <Image src={logo} alt='logo' width={57}/>
                    <div className='text-[#D0D0E3] text-[27px] font-bold tracking-[-1.226px]'>
                        Luminode Labs
                    </div>
                </div>
                <div className='text-textColor text-[16px]'>
                    <ul className='flex gap-8'>
                        <li className='cursor-pointer opacity-80 hover:opacity-100'>Mission</li>
                        <li className='cursor-pointer opacity-80 hover:opacity-100'>Expertises</li>
                        <li className='cursor-pointer opacity-80 hover:opacity-100'>Advantage</li>
                        <li className='cursor-pointer opacity-80 hover:opacity-100'>Team</li>
                    </ul>
                </div>
            </header>
        </div>
    )
}

export default Header;